import React, { useContext, useMemo, useEffect } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import classNames from 'classnames';

import Header from '../../components/layout/Header';
import { Button } from '../../components/_shared';
import { Container } from '../Courses/Courses.styled';
import { AppContext } from '../../providers/AppProvider';
import { makeSelectIsIcscOrg } from '../../store/selectors';
import { isEnterprise, isMMI } from '../../config';
import routes from '../../routes';
import brandIcon from '../../assets/imgs/rabbit.png';
import './Home.scss';

const Content = styled.div`
  @media only screen and (max-width: 639px) {
    &.content {
      margin: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 50px 16px;

      .content__title {
        font-size: 24px;
        font-weight: 500;
      }

      .divider {
        margin-top: 10px;
        margin-bottom: 24px;
      }

      .content__text {
        font-size: 18px;
        font-weight: 500;
      }

      .brand-icon {
        width: 53px;
        height: 40px;
        margin-top: 34px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
`;

const Home = () => {
  const history = useHistory();
  const { progress, coreCurriculum, program } = useContext(AppContext);
  const isIcsc = useSelector(makeSelectIsIcscOrg());

  const hasProgress = useMemo(() => {
    return progress.some(
      (cur) => cur.completedLessons.length || cur.completedQuizzes.length
    );
  }, [progress]);

  const handleGetStarted = () => {
    if (program && coreCurriculum) {
      const programId = program.id;
      const coreCurId = coreCurriculum.id;
      const firstCourse =
        coreCurriculum.courseNos.indexOf(
          Math.min(...coreCurriculum.courseNos)
        ) || 0;
      const courseId = coreCurriculum.courses[firstCourse].id;
      history.push(`/programs/${programId}/${coreCurId}/courses/${courseId}`);
    }
    // history.push(user ? routes.PROGRAMS : routes.SIGN_IN);
  };

  if (hasProgress) {
    history.push(routes.PROGRAMS);
  }

  return (
    <div className={classNames('home-container h-screen', isIcsc && 'icsc')}>
      <Container className="w-full h-full m-auto z-10 sm:flex sm:flex-col">
        <Header className="header" />
        <Content className="content w-full sm:w-full sm:p-4 sm:flex-grow">
          <div></div>
          <div className="sm:flex sm:flex-col sm:items-center sm:px-9">
            <div className="content__title text-white sm:text-center">
              {isEnterprise
                ? isIcsc
                  ? 'ICSC Retail Real Estate Modeling'
                  : isMMI ? 'Welcome to the Accelerator for Marcus and Millichap' : 'Welcome to the Accelerator for Enterprise'
                : 'Welcome to the Accelerator'}
            </div>
            <div className="divider" />
            <div className="content__text w-1/2 text-white sm:text-center">
              Click the button below to begin your journey toward real estate
              financial modeling excellence.
            </div>
            {!isIcsc ? (
              <img
                className="brand-icon sm:mx-auto"
                src={brandIcon}
                alt="brand_icon"
              />
            ) : (
              <div className="mt-4 mb-8" />
            )}
          </div>
          <Button
            type="misc"
            className="w-56 py-3 px-9 bg-light-yellow rounded-lg text-white mt-4 font-bold sm:mx-auto sm:mt-0 sm:w-full"
            caption="Get Started"
            onClick={handleGetStarted}
          />
        </Content>
      </Container>
    </div>
  );
};

export default Home;
